/**
 * RedirectGuard — Checks current path against admin-managed redirect table
 * and navigates to the new URL if a match is found.
 *
 * Mounted once at app root; on every route change, queries /api/redirects/match.
 * If matched: internal → React Router navigate; external → window.location.replace.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function RedirectGuard() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Skip system paths
        const path = location.pathname;
        if (
            path.startsWith("/admin") ||
            path.startsWith("/h/") ||
            path.startsWith("/api") ||
            path === "/login" ||
            path === "/staff-login"
        ) return;
        let cancelled = false;
        api.get(`/redirects/match?path=${encodeURIComponent(path)}`)
            .then((r) => {
                if (cancelled) return;
                const m = r.data;
                if (!m?.match) return;
                if (m.to.startsWith("http")) {
                    window.location.replace(m.to);
                } else {
                    navigate(m.to, { replace: true });
                }
            })
            .catch(() => { /* 404 = no match, expected */ });
        return () => { cancelled = true; };
    }, [location.pathname, navigate]);

    return null;
}
